<script lang="ts">
  import 'bootstrap/js/dist/modal';
  import { createEventDispatcher } from 'svelte';
  import { getStr, globalCurrencyTag } from '../../../common/util';
  import Text from '../../common/components/Text.svelte';
  import Icon from '../../common/components/Icon.svelte';

  export let gift;
  export let selectedGiftsGroups;
  export let index;
  export let isFixedGift;
  export let selectedGifts;
  export let activeGroup;

  let dispatch = createEventDispatcher();
  function handleDiscountCheckbox(event) {
    dispatch('handleDiscountCheckbox', {
      e: event,
      gift: 'discount',
      index: index,
    });
  }
</script>

<div class="gift-option-card">
  <div class="gift-option-main">
    <div class="free-gift-product-img">
      <Icon type="url" desktopSize={66} mobileSize={42} glyph={getStr('extra.ac.promotion.discount.icon.url')} />
    </div>
    <div class="product-description">
      <span class="item-name">{getStr('extra.ac.promotion.additional.discount.text')}</span>
      <div class="item-subcopy">
        <Text
          key="extra.ac.promotion.additional.discount.price.text"
          args={[`${globalCurrencyTag}`, `${gift.acPriceDiscountValue?.formattedValue}`]}
        />
      </div>
    </div>
  </div>
  <div class="gift-option-meta">
    <div class="selection-box">
      {#if !isFixedGift}
        <label class="custom-checkbox cb2">
          <input
            type="checkbox"
            name="fgProductCodes"
            class:selected={selectedGiftsGroups[index].includes('discount')}
            disabled={isFixedGift ||
              (activeGroup !== index && activeGroup !== -1) ||
              (!selectedGiftsGroups[index].includes('discount') &&
                selectedGiftsGroups[index].length == gift.freeGiftQtuantities.sourceQty)}
            bind:group={$selectedGifts}
            value="discount"
            on:change={event => handleDiscountCheckbox(event)}
          />
          <span />
        </label>
      {/if}
    </div>
  </div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .free-gift-product-img {
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    @include desktop-min-width {
      width: 88px;
      height: 88px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .gift-option-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 18px 20px;
  }

  .gift-option-main {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
    flex: 1;
  }

  .selection-box {
    text-align: end;
    .custom-checkbox input {
      display: none;
    }

    .custom-checkbox span {
      border: 2px solid #d3dce5;
      border-radius: 6px;
      height: 28px;
      width: 28px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: $primary-white;
    }

    .custom-checkbox input:checked + span:before {
      content: '✔';
    }

    .custom-checkbox input:checked + span {
      background: $icon-only-icon-blue;
      border-color: $icon-only-icon-blue;
    }
  }

  .product-description {
    min-width: 0;
    .item-name {
      display: block;
      font-size: 18px;
      line-height: 24px;
      font-weight: 500;
      color: $neutral-dark-02;
    }
    .item-subcopy {
      margin-top: 6px;
      font-size: 14px;
      line-height: 18px;
      color: $neutral-dark-01;
    }
  }

  .gift-option-meta {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }

  .discount-label {
    color: $functional-green-01;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
  }

  @include desktop-max-width {
    .gift-option-card {
      padding: 16px;
    }
    .product-description .item-name {
      font-size: 16px;
      line-height: 20px;
    }
    .selection-box .custom-checkbox span {
      width: 24px;
      height: 24px;
    }
  }
</style>
